export const returnProductSlugUrl = (slug, selectedVariant, targetDiopter) => {
  const searchParams = new URLSearchParams();

  if (selectedVariant?.size)
    searchParams.set('size', selectedVariant?.size.value);
  if (selectedVariant?.color)
    searchParams.set(
      'color',
      selectedVariant?.color.shopifyKey.toLocaleLowerCase()
    );
  if (targetDiopter) searchParams.set('diopter', targetDiopter);

  return `${slug.url}${
    searchParams.toString() === '' ? '' : '?'
  }${searchParams.toString()}`;
};
